import type {SupportedLocale} from '@github-ui/swp-core/lib/utils/localization'

import type {BannerDescriptor} from './marketing-global-banner.types'

/**
 * To add a banner, append a descriptor here and register its `feature_flag` in the `jsFeatureFlags`
 * allowlist in `@github-ui/feature-flags`, or it will never be enabled client-side.
 */
export function getBannerRegistry(_locale?: SupportedLocale): BannerDescriptor[] {
  return [
    {
      uid: 'universe26_seblaunch',
      title: 'Find your people at GitHub Universe (and save $300 through Aug 19).',
      link: 'https://githubuniverse.com/?utm_source=github&utm_medium=banner&utm_campaign=gb_eblaunch_uni26',
      link_label: 'Register now',
      mode: 'light',
      custom_design: 'universe_26',
      allowed_paths: [
        '/open-source/sponsors',
        '/open-source/accelerator',
        '/enterprise',
        '/enterprise/startups',
        '/features/copilot/copilot-business',
        '/team',
        '/security/advanced-security',
      ],
      feature_flag: 'universe26_banners_seblaunch',
    },
    {
      uid: 'desktop_copilot_app',
      title: 'Looking for an agent-driven desktop experience?',
      link: 'https://github.com/features/ai/github-app?utm_source=github&utm_medium=banner&utm_campaign=desktop_copilot_app',
      link_label: 'Download the GitHub Copilot app',
      mode: 'dark',
      allowed_paths: ['/apps/desktop'],
      feature_flag: 'site_banner_desktop_copilot_app',
    },
    {
      uid: 'learn_copilot_app',
      title:
        'This July, learn how to use the GitHub Copilot app to explore issues, build features, and review changes in parallel, without switching between tools. No experience required!',
      link: 'https://gh.io/letslearn',
      link_label: 'Register',
      mode: 'dark',
      allowed_paths: ['/features/ai/github-app'],
      feature_flag: 'site_global_banner_learn_copilot_app',
    },
    {
      uid: 'security_webinar',
      title: 'Secret Leaks: Trends, Risks, and How to Respond',
      link: 'https://github.registration.goldcast.io/webinar/77c2c07e-1cd1-4f17-9f4c-7d1500a658e9?utm_source=gh_web_banner&utm_medium=web&utm_campaign=SecurityPodJuly28',
      link_label: 'Register now',
      mode: 'dark',
      allowed_paths: [
        '/security',
        '/security/advanced-security/secret-protection',
        '/security/advanced-security/code-security',
      ],
      feature_flag: 'site_global_banner_security_webinar',
    },
  ]
}
